import { useEffect } from 'react'
import { withRouter } from '../utils'

function Logout({ navigate }) {
  useEffect(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('user_role')
    navigate('/login')
  }, [navigate])
  return null
}

export default withRouter(Logout)
